import { bootstrapApplication } from '@angular/platform-browser';
import { provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling, withNavigationErrorHandler } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { reloadWhenThePageCodeIsGone } from './app/core/reload-after-deploy';
import { authInterceptor } from './app/interceptors/auth.interceptor';
import { errorInterceptor } from './app/interceptors/error.interceptor';
import { superAdminInterceptor } from './app/interceptors/super-admin.interceptor';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor, superAdminInterceptor, errorInterceptor])),
    // Start each page at the top, and scroll to #kosten and #waarom on the home page. A page whose code is gone
    // after a new deploy is loaded anew.
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withNavigationErrorHandler(reloadWhenThePageCodeIsGone),
    )
  ]
}).catch(err => console.error(err));
